import NoData from '@/components/common/NoData'
import TableFooter from '@/components/common/Table/TableFooter'
import ButtonField from '@/components/form-control/ButtonField'
import { CharacterPlusIcon } from '@/components/icons'
import { flyInVariantsDashboard, SortBy } from '@/constant/common'
import { useAuthContext } from '@/features/auth/context'
import { usePermission } from '@/hooks/permissions'
import { SearchParams } from '@/types'
import { usePagination } from '@mui/lab'
import { CircularProgress, SelectChangeEvent, Stack } from '@mui/material'
import { motion } from 'framer-motion'
import { debounce } from 'lodash'
import { useEffect, useState } from 'react'
import { useConfigUI } from '../../../context'
import TurfQualityTable from './TurfQualityTable'
import classes from './style.module.scss'
import useTranslation from '@/hooks/useTranslation'
import useSearchTurfQuality from '@/features/config/hooks/turfQuality/useSearchTurfQuality'

const MotionDiv = motion.div

const TurfQuality = ({ reloadKey }: { reloadKey?: number }) => {
  const { openSidebar, setSidebarView } = useConfigUI()
  const { openModal, setModalView } = useConfigUI()

  const { interfaceId } = useAuthContext()
  const { isViewOnly } = usePermission()
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useState<SearchParams>({
    PageSize: 10,
    PageIndex: 1,
  })
  const [currentPage, setCurrentPage] = useState(1)
  const { data, refetch } = useSearchTurfQuality(searchParams, Number(interfaceId))

  useEffect(() => {
    if (reloadKey !== undefined) {
      refetch()
    }
  }, [reloadKey, refetch])

  const handleAddTurfQuality = () => {
    // ViewOnly users cannot add 
    if (isViewOnly) return

    openSidebar()
    setSidebarView({ type: 'TURFQUALITY_VIEW' })
  }

  const handleDelete = (id: number | string, interfaceId: number | string) => {
    // ViewOnly users cannot delete 
    if (isViewOnly) return

    openModal()
    setModalView({
      type: 'DELETE_TURF_QUALITY_VIEW',
      id: id.toString(),
      interfaceId: String(interfaceId),

      onSuccess: async () => {
        const newData = await refetch()
        if (newData.data?.list.length === 0 && currentPage !== 1) {
          setCurrentPage(currentPage - 1)
        }

        const newCurrentPage =
          newData.data?.list.length === 0 && currentPage !== 1
            ? currentPage - 1
            : currentPage

        setSearchParams({
          ...searchParams,
          PageIndex: newCurrentPage,
        })
      },
    })
  }


  return (
    <Stack className={classes.wrapper}>
      <Stack flexGrow="1" height="100%" paddingTop="1em">
        <Stack
          direction={'row'}
          justifyContent={'flex-end'}
          className={classes.header}
        >
          {!data || data?.list?.length < 10 &&
            <ButtonField
              startIcon={<CharacterPlusIcon />}
              style={{
                height: '32px',
                minWidth: '89px',
                borderRadius: '5px',
              }}
              name={t('newTurfQuality')}
              onClick={handleAddTurfQuality}
              disabled={isViewOnly}
              sx={{ opacity: isViewOnly ? 0.6 : 1 }}
            />
          }
        </Stack>

        <MotionDiv
          initial="initial"
          animate="animate"
          variants={flyInVariantsDashboard}
          className={classes.content}
        >
          {!data && (
            <Stack className={classes.circleProgress}>
              <CircularProgress />
            </Stack>
          )}

          {data && data?.list.length > 0 && (
            <TurfQualityTable
              rows={data.list}
              onDelete={handleDelete}
            />
          )}

          {data && data.totalCount === 0 && (
            <NoData text={t('commonStatusNoData')} />
          )}
        </MotionDiv>

      </Stack>
    </Stack>
  )
}

export default TurfQuality
